import { lazy } from "react";
import { ElementDetails } from "@/lib/types";
import { Bitrix24WorkReportsProps } from "./types";

export const details = {
  name: "Bitrix24WorkReports",
  description: "Review your Bitrix24 daily work reports at a glance.",
  tags: ["Business", "Productivity"],
  category: "Bitrix24",
  grid: {
    "default": [4, 4],
    "6x4": [4, 6],
    "6x6": [6, 6],
    "8x4": [8, 4],
    "8x6": [8, 6],
  },
  gridNames: {
    "default": "Small",
    "6x4": "Medium",
    "6x6": "Large",
    "8x4": "Extra Long",
    "8x6": "Extra Large",
  },
  app: lazy(() => import("./App").then(m => ({ default: m.App }))),
  integrationsUsed: ["bitrix24"],
  defaultProps: {},
} as ElementDetails<Bitrix24WorkReportsProps>;
